import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  unitsFilter: string;
  fields: string[];
  translatedMessage: string;
}

const initialState: StateInterface = {
  unitsFilter: "all",
  fields: [],
  translatedMessage: ""
};

export const unitsPageReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.GLOBAL_UNIT_UPDATE_REQUEST:
      return {
        ...state,
      };

    case Constants.GLOBAL_UNIT_UPDATE_SUCCESS:
      return {
        ...state,
      };

    case Constants.GLOBAL_UNIT_UPDATE_FAILURE:
      return {
        ...state,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.PAGE_UNITS_UNITS_FILTER:
      return {
        ...state,
        unitsFilter: action.payload?.filter
      };

    case Constants.GLOBAL_CHARGE_TYPE_CREATE_FAILURE:
      return {
        ...state,
       // isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_UNIT_CREATE_FAILURE:
      return {
        ...state,
        fields: action.payload?.err && action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };   
      
    case Constants.GLOBAL_CHARGE_TYPE_CREATE_CLEAR:
    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
